export default {
  getStateLoader: state => state.loader,

  getCity: state => state.route.params.city,
  getRouteName: state => state.route.name,
  getSpeakerName: state => state.route.params.speaker,

  getStructure: state => (city, page) => state.pages[city][page],
  getComponents: state => state.components,

  getImageAlt: state => (pictureUrl) => {
    const foundKey = Object.keys(state.media).find((key) => {
      return state.media[key].url === pictureUrl;
    });
    if (typeof foundKey !== 'undefined' && typeof state.media[foundKey].alt !== 'undefined') {
      return state.media[foundKey].alt
    } else {
      return '';
    }
  },
};
